export default __webpack_public_path__ + "3dd4251fb3ab864bba01588f762ee97b.svg";